export default function WizardProgress() {
  return null;
}
